export const VERSION_CHECK_INTERVAL_SEC = 60;
export const VERSION_CHECK_MESSAGE =
  "Мы обновили приложение! Для доступа к новой функциональности страница будет перезагружена";
export const ORDER_PRIORITY_OPTIONS = [
  { value: 0, text: "Обычный" },
  { value: 1, text: "Критический" }
];
export const WEBSOCKET_URL = "wss://develop.auraonline.ru:50082/ws/";
//export const WEBSOCKET_URL = "wss://auraonline.ru:8000/ws/";
